export const kn = {
  tip: "ಸಲಹೆ",
  fatInputTip: "ನೀವು {val}.0 ಬರೆಯಲು ಬಯಸಿದರೆ ದಶಮಾಂಶದೊಂದಿಗೆ ನಿಖರವಾದ ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿ ಅಥವಾ 3 ಅಂಕೆಗಳೊಂದಿಗೆ {val}0 ನಮೂದಿಸಿ.",
  snfInputTip: "ನೀವು {val}.0 ಬರೆಯಲು ಬಯಸಿದರೆ ದಶಮಾಂಶದೊಂದಿಗೆ ನಿಖರವಾದ ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿ ಅಥವಾ 3 ಅಂಕೆಗಳೊಂದಿಗೆ {val}0 ನಮೂದಿಸಿ.",
  // Header/Navigation
  // appTitle: "ದುಧಿಯಾ: ಹಾಲು ನಿರ್ವಹಣಾ ವ್ಯವಸ್ಥೆ",
  home: "ಹೋಮ್",
  logout: "ಲಾಗ್‌ಔಟ್",

  // Hire Person
  hirePersonBannerHeading: "ನೀವು ಸಂಗ್ರಹಣೆಯನ್ನು ಸ್ವಯಂ ಮಾಡಲು ಬಯಸುವುದಿಲ್ಲವೇ?",
  hirePersonBannerSubheading: "ಸಂಗ್ರಹಣೆಗಾಗಿ ಒಬ್ಬ ವ್ಯಕ್ತಿಯನ್ನು ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ",
  hirePersonModalTitle: "ಸಂಗ್ರಹಣೆಗಾಗಿ ವ್ಯಕ್ತಿಯನ್ನು ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ",
  hirePersonCostEstimate: "ವೆಚ್ಚ ಅಂದಾಜು",
  hirePersonCostEstimateDesc: "ಬೆಲೆಯು ಸಾಮಾನ್ಯವಾಗಿ ದೈನಂದಿನ ಸರಾಸರಿ ಸಂಗ್ರಹಣೆಗಳ ಸಂಖ್ಯೆ ಮತ್ತು ಅಗತ್ಯ ಕೆಲಸದ ಪ್ರಮಾಣದ ಆಧಾರದ ಮೇಲೆ ₹500 ರಿಂದ ₹3,000-₹4,000 ಪ್ರತಿ ತಿಂಗಳಿಗೆ ಇರುತ್ತದೆ.",
  hirePersonContactNetpy: "ದುಧಿಯಾ ಸಹಾಯವನ್ನು ಸಂಪರ್ಕಿಸಿ",
  hirePersonContactNetpyDesc: "ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ವಿಶ್ವಾಸಾರ್ಹ ಸಂಗ್ರಹಣೆ ಸಿಬ್ಬಂಧಿಗಳೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಲು ಮತ್ತು ಕಸ್ಟಮೈಸ್ಡ್ ಕೋಟ್ ಪಡೆಯಲು ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.",
  hirePersonCallNetpy: "ಕಾಲ್ ನೆಟ್ಪೈ",
  hirePersonWhatsAppNetpy: "ವಾಟ್ಸ್ಆಪ್ ನೆಟ್ಪೈ",

  // Dashboard
  dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
  dairyName: "ಡೈರಿಯ ಹೆಸರು",
  walletBalance: "ವಾಲೆಟ್ ಶೇಷ",
  addMoney: "ಹಣ ಸೇರಿಸಿ",
  notAvailable: "ಲಭ್ಯವಿಲ್ಲ",

  // Rate Information
  milkRate: "ಹಾಲಿನ ದರ",
  currentRate: "ಪ್ರಸ್ತುತ ದರ",
  currentMilkRate: "ಪ್ರಸ್ತುತ ಹಾಲಿನ ದರ",
  editRate: "ದರ ಸಂಪಾದನೆ",
  rateType: "ದರದ ಪ್ರಕಾರ",
  selectRateType: "ದರದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  submit: "ಸಲ್ಲಿಸಿ",
  submitting: "ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...",
  save: "ಉಳಿಸಿ",
  saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
  cancel: "ರದ್ದುಗೊಳಿಸಿ",

  // Dashboard Cards
  bulkRateUpdate: "ಬಲ್ಕ್‌ನಲ್ಲಿ ಹಾಲಿನ ದರವನ್ನು ಬದಲಿಸಿ",
  bulkRateUpdateBtn: "ದರ ಅಪ್‌ಡೇಟ್",
  bulkRateUpdateTooltip: "ಹಲವಾರು ಸಂಗ್ರಹಗಳಿಗೆ ಹಾಲಿನ ದರ ಬದಲಾಯಿಸಿ",
  rateSettings: "ದರ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
  updateRatesForMultipleCollections: "ಹಲವಾರು ಸಂಗ್ರಹಗಳಿಗೆ ದರಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  configureMilkPricingAndRateTypes: "ಹಾಲಿನ ಬೆಲೆ ಮತ್ತು ದರದ ಪ್ರಕಾರಗಳನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಿ",
  updateMultipleCollectionsAtOnce: "ಒಂದೇ ಬಾರಿಗೆ ಹಲವಾರು ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  previewBeforeApplyingChanges: "ಬದಲಾವಣೆಗಳನ್ನು ಅನ್ವಯಿಸುವ ಮೊದಲು ಮುನ್ನೋಟಿಸಿ",
  setCurrentMilkRate: "ಪ್ರಸ್ತುತ ಹಾಲಿನ ದರವನ್ನು ಹೊಂದಿಸಿ",
  setMilkRateNow: "ನಿಮ್ಮ ಹಾಲಿನ ದರವನ್ನು ಈಗ ಹೊಂದಿಸಿ!",
  managePricingParameters: "ಬೆಲೆ ನಿರ್ಧಾರಕ ಪ್ಯಾರಾಮೀಟರ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
  applyToSpecificDateRanges: "ನಿರ್ದಿಷ್ಟ ದಿನಾಂಕ ಶ್ರೇಣಿಗಳಿಗೆ ಅನ್ವಯಿಸಿ",
  configureRateType: "ದರದ ಪ್ರಕಾರವನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಿ (FAT+SNF, FAT+CLR, ಇತ್ಯಾದಿ)",

  // Collection Cards
  regularMilkCollections: "ನಿಯಮಿತ ಹಾಲಿನ ಸಂಗ್ರಹಗಳು",
  proportionalCollections: "ಅನುಪಾತೀಯ ಸಂಗ್ರಹಗಳು",
  generateDetailedReports: "ವಿವರಣಾತ್ಮಕ ವರದಗಳನ್ನು ರಚಿಸಿ",
  proRataCollection: "ಪ್ರೊ-ರಾಟಾ ಸಂಗ್ರಹ",
  standardCollection: "ಪ್ರಮಾಣಿತ ಸಂಗ್ರಹ",
  notAvailableWithKGLitersRateType: "ಕೆಜಿ/ಲೀಟರ್ ದರದ ಪ್ರಕಾರದೊಂದಿಗೆ ಲಭ್ಯವಿಲ್ಲ",
  selectCollectionType: "ಸಂಗ್ರಹದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  applyFilter: "ಫಿಲ್ಟರ್ ಅನ್ವಯಿಸಿ",
  applying: "ಅನ್ವಯಿಸುತ್ತಿದೆ...",
  applyRateChanges: "ದರದ ಬದಲಾವಣೆಗಳನ್ನು ಅನ್ವಯಿಸಿ",

  // Wallet Modal
  addToWallet: "ವಾಲೆಟ್‌ಗೆ ಸೇರಿಸಿ",
  topUpWalletInstantlyUsingRazorpay: "ರೇಜರ್‌ಪೇ ಬಳಸಿ ತಕ್ಷಣವೇ ನಿಮ್ಮ ವಾಲೆಟ್ ಅನ್ನು ಟಾಪ್ ಅಪ್ ಮಾಡಿ",
  quickRecharge: "ತ್ವರಿತ ರಿಚಾರ್ಜ್",
  walletRecharge: "ರಿಚಾರ್ಜ್",

  // Add Money Modal
  moneyAddedToWalletMessage: "ಯಶಸ್ವಿ ಪಾವತಿಯ ನಂತರ 5 ನಿಮಿಷಗಳಲ್ಲಿ ಹಣ ನಿಮ್ಮ ವಾಲೆಟ್‌ಗೆ ಸೇರಿಸಲಾಗುತ್ತದೆ.",
  refreshPage: "ಪುಟವನ್ನು ರಿಫ್ರೆಶ್ ಮಾಡಿ",
  please: "ದಯವಿಟ್ಟು",
  enterAmount: "ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ",
  enterValidAmount: "ಮಾನ್ಯವಾದ ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ (₹1 ಅಥವಾ ಹೆಚ್ಚು)",
  youWillGetExtraOnRecharge: "ನೀವು ಈ ರಿಚಾರ್ಜ್‌ನಲ್ಲಿ ₹{amount} ಹೆಚ್ಚು ಪಡೆಯುತ್ತೀರಿ!",
  youWillGet10PercentBonus: "ನೀವು ಈ ರಿಚಾರ್ಜ್‌ನಲ್ಲಿ ₹{amount} ಹೆಚ್ಚು ಪಡೆಯುತ್ತೀರಿ!",
  youWillGet5PercentBonus: "ನೀವು ಈ ರಿಚಾರ್ಜ್‌ನಲ್ಲಿ ₹{amount} ಹೆಚ್ಚು ಪಡೆಯುತ್ತೀರಿ!",
  continueToPayment: "ಪಾವತಿಗೆ ಮುಂದುವರಿರಿ",
  loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",

  // Rate Settings Modal
  saveSettings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಉಳಿಸಿ",
  perKg: "/ಕೆಜಿ",
  milkRateHeading: "ಹಾಲಿನ ದರ",
  milkRateAndRateSettingsSavedSuccessfully: "ಹಾಲಿನ ದರ ₹{currentRate}/ಕೆಜಿ ಮತ್ತು ದರ ಸೆಟ್ಟಿಂಗ್‌ಗಳು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!",

  // Collections
  addCollection: "ಮೊತ್ತ ಸಂಗ್ರಹ",
  viewCollections: "ಸಂಗ್ರಹ ವೀಕ್ಷಿಸಿ",
  standardCollections: "ಪ್ರಮಾಣಿತ ಸಂಗ್ರಹ",
  proRataCollections: "ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹ",
  quickFiltersAndActions: "ತ್ವರಿತ ಫಿಲ್ಟರ್‌ಗಳು ಮತ್ತು ಕ್ರಮಗಳು",
  refineCollectionsAndManageRatesInstantly: "ನಿಮ್ಮ ಸಂಗ್ರಹಗಳನ್ನು ಪರಿಷ್ಕರಿಸಿ ಮತ್ತು ತಕ್ಷಣವೇ ದರಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
  proRataFiltersAndActions: "ಪ್ರೋ-ರಾಟಾ ಫಿಲ್ಟರ್‌ಗಳು ಮತ್ತು ಕ್ರಮಗಳು",
  targetCollectionsAndUpdateProRataRatesFaster: "ಸಂಗ್ರಹಗಳನ್ನು ಗುರಿಯಾಗಿಸಿ ಮತ್ತು ಪ್ರೋ-ರಾಟಾ ದರಗಳನ್ನು ವೇಗವಾಗಿ ನವೀಕರಿಸಿ",
  proRataBadge: "ಪ್ರೋ ರಾಟಾ",

  // Customer Management
  addCustomer: "ಗ್ರಾಹಕ ಸೇರಿಸಿ",
  viewCustomers: "ಗ್ರಾಹಕರನ್ನು ವೀಕ್ಷಿಸಿ",
  customerName: "ಗ್ರಾಹಕರ ಹೆಸರು",
  phoneNumber: "ಫೋನ್ ಸಂಖ್ಯೆ",

  // Reports
  generateReports: "ವರದಿಯನ್ನು ರಚಿಸಿ",
  reports: "ವರದಿಗಳು",
  generateStandardReport: "ವರದಿ ರಚಿಸಿ",
  generateProRataReport: "ವರದಿ ರಚಿಸಿ",

  // Wallet
  wallet: "ವಾಲೆಟ್",
  addFunds: "ಹಣ ಸೇರಿಸಿ",
  amount: "ಮೊತ್ತ",
  paymentSuccessful: "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ! ನಿಮ್ಮ ವಾಲೆಟ್ ಶೀಘ್ರದಲ್ಲೇ ನವೀಕರಿಸಲಾಗುತ್ತದೆ.",
  paymentSuccessfulWithAmount: "✅ ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ! ₹{amount} ನಿಮ್ಮ ವಾಲೆಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ.",
  paymentFailed: "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  paymentCancelled: "ಪಾವತಿ ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ. ನೀವು ಹಣ ಸೇರಿಸಲು ಬಯಸಿದರೆ ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  paymentSessionTimedOut: "ಪಾವತಿ ಸಮಯ ಮುಗಿದಿದೆ. ಪಾವತಿ ಪೂರ್ಣಗೊಂಡಿದೆಯೇ ಪರಿಶೀಲಿಸಿ.",
  paymentCancelledOrIncomplete: "ಪಾವತಿ ರದ್ದು ಅಥವಾ ಅಪೂರ್ಣ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  unableToVerifyPaymentStatus: "ಪಾವತಿ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಲು ಸಾಧ್ಯವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಪರಿಶೀಲಿಸಿ.",

  // Collection Details
  singleDateShift: "ಏಕ ದಿನಾಂಕ/ಶಿಫ್ಟ್",
  multiDateShift: "ಬಹು ದಿನಾಂಕ/ಶಿಫ್ಟ್",
  date: "ದಿನಾಂಕ",
  time: "ಸಮಯ",
  dateTime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
  customer: "ಗ್ರಾಹಕ",
  weight: "ತೂಕ",
  fatPercentage: "FAT %",
  snfPercentage: "SNF %",
  fatKg: "ಕೊಬ್ಬು ಕೆಜಿ",
  snfKg: "ಎಸ್ಎನ್‌ಎಫ್ ಕೆಜಿ",
  fatRate: "FAT ದರ",
  snfRate: "SNF ದರ",
  baseSNF: "ಮೂಲ SNF",
  totalAmount: "ಒಟ್ಟು ಮೊತ್ತ",
  finalAmount: "ಅಂತಿಮ ಮೊತ್ತ",
  avgFat: "ಸರಾಸರಿ FAT",
  avgSnf: "ಸರಾಸರಿ SNF",
  totalQuantity: "ಒಟ್ಟು ಪ್ರಮಾಣ",
  totalFat: "ಒಟ್ಟು FAT",
  totalSnf: "ಒಟ್ಟು SNF",
  totalSolidWeight: "ಒಟ್ಟು ಘನ ತೂಕ",

  // Common
  error: "ದೋಷ",
  success: "ಯಶಸ್ಸು",
  confirm: "ದೃಢೀಕರಿಸಿ",
  edit: "ಸಂಪಾದಿಸಿ",
  delete: "ಅಳಿಸಿ",
  add: "ಸೇರಿಸಿ",
  update: "ನವೀಕರಿಸಿ",
  close: "ಮುಚ್ಚಿ",

  // Units
  kg: "ಕೆಜಿ",
  currency: "₹",

  // Messages
  loadingInformation: "ಮಾಹಿತಿ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
  loadingDairyInformation: "ಡೈರಿ ಮಾಹಿತಿ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
  loadingUserInformation: "ಬಳಕೆದಾರ ಮಾಹಿತಿ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
  dairy: "ಡೈರಿ",
  balance: "ಶೇಷ",
  changeType: "ಪ್ರಕಾರ ಬದಲಾಯಿಸಿ",
  processing: "ಪ್ರೊಸೆಸಿಂಗ್...",
  submittingCollections: "ಸಂಗ್ರಹಗಳನ್ನು ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ",
  processingCollections: "{total} ರಲ್ಲಿ {current} ಸಂಗ್ರಹಗಳನ್ನು ಪ್ರೊಸೆಸ್ ಮಾಡಲಾಗುತ್ತಿದೆ",
  noDataYet: "ಇನ್ನೂ ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ. ಸಂಗ್ರಹಗಳನ್ನು ಸೇರಿಸಲು ಪ್ರಾರಂಭಿಸಲು 'ಸಾಲು ಸೇರಿಸಿ' ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ.",
  loadingRateInformation: "ದರದ ಮಾಹಿತಿ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",

  // Footer
  // allRightsReserved: "ಎಲ್ಲ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ",
  poweredBy: "ಇವರಿಂದ ಚಾಲಿತ",

  // Login
  login: "ಲಾಗಿನ್",
  enterPhoneNumber: "ನಿಮ್ಮ 10 ಅಂಕೆಯ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
  verifyOTP: "OTP ಪರಿಶೀಲಿಸಿ",
  enterOTP: "OTP ನಮೂದಿಸಿ",
  changeNumber: "ಸಂಖ್ಯೆ ಬದಲಾಯಿಸಿ",

  // Language Names
  english: "English",
  hindi: "हिन्दी",
  punjabi: "ਪੰਜਾਬੀ",
  kannada: "ಕನ್ನಡ",

  // Bulk Collection
  bulkCollection: "ಮೊತ್ತ ಸಂಗ್ರಹ",
  prorataBulkCollection: "ಪ್ರೊ-ರಾಟಾ ಮೊತ್ತ ಸಂಗ್ರಹ",
  prorataViewCollections: "ಸಂಗ್ರಹಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
  bulkCollectionSpreadsheetView: "ಮೊತ್ತ ಸಂಗ್ರಹ - ಸ್ಪ್ರೆಡ್‌ಶೀಟ್ ವೀಕ್ಷಣ",
  backToDashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂತಿರುಗಿ",
  owner: "ಮಾಲೀಕ",
  phone: "ಫೋನ್",
  collectionDate: "ಸಂಗ್ರಹ ದಿನಾಂಕ (ಎಲ್ಲಾ ಸಾಲುಗಳಿಗೆ)",
  collectionTime: "ಸಂಗ್ರಹ ಸಮಯ (ಎಲ್ಲಾ ಸಾಲುಗಳಿಗೆ)",
  customerManagement: "ಗ್ರಾಹಕ ನಿರ್ವಹಣೆ",
  rateConfiguration: "ದರ ಸಂರಚನೆ",
  changeRates: "ದರಗಳನ್ನು ಬದಲಾಯಿಸಿ",
  add1Row: "1 ಸಾಲು ಸೇರಿಸಿ",
  add5Rows: "5 ಸಾಲುಗಳನ್ನು ಸೇರಿಸಿ",
  previewSubmit: "ಪೂರ್ವವೀಕ್ಷಣೆ ಮತ್ತು ಸಲ್ಲಿಸಿ",
  collectionDateEdit: "ಕಲೆಕ್ಷನ್ ದಿನಾಂಕ",
  collectionTimeEdit: "ಕಲೆಕ್ಷನ್ ಸಮಯ",

  // Table Headers
  serialNumber: "#",
  // weightKg: "ತೂಕ (ಕೆಜಿ)",
  fatPercent: "FAT %",
  snfPercent: "SNF %",
  clr: "CLR",
  actions: "ಕ್ರಿಯೆಗಳು",

  // Form Fields
  searchCustomer: "ಗ್ರಾಹಕ ಹುಡುಕಿ",
  rate: "ದರ (₹)",

  // Options
  morning: "ಬೆಳಿಗ್ಗೆ",
  evening: "ಸಂಜೆ",
  cow: "ಹಸು",
  buffalo: "ಎಮ್ಮೆ",
  cowBuffalo: "ಹಸು + ಎಮ್ಮೆ",

  // Shift Filter Options
  allShifts: "ಬೆಳಗ್ಗೆ + ಸಂಜೆ",
  morningAm: "ಬೆಳಗ್ಗೆ",
  eveningPm: "ಸಂಜೆ",

  // Actions
  submitAll: "ಎಲ್ಲವನ್ನೂ ಸಲ್ಲಿಸಿ",

  // New Customer Modal
  name: "ಹೆಸರು",
  fatherName: "ತಂದೆಯ ಹೆಸರು",
  village: "ಗ್ರಾಮ",
  address: "ವಿಳಾಸ",
  enterCustomerName: "ಗ್ರಾಹಕರ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  enterFatherName: "ತಂದೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  enter10DigitPhone: "10-ಅಂಕೆಯ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
  enterVillageName: "ಗ್ರಾಮದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  enterCompleteAddress: "ಸಂಪೂರ್ಣ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
  saveCustomer: "ಗ್ರಾಹಕರನ್ನು ಉಳಿಸಿ",

  // Messages
  noCollectionsAdded: "ಇನ್ನೂ ಯಾವುದೇ ಸಂಗ್ರಹಗಳನ್ನು ಸೇರಿಸಲಾಗಿಲ್ಲ. ಸಂಗ್ರಹವನ್ನು ಸೇರಿಸಲು ಕೆಳಗಿನ ಬಟನ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ.",
  collectionSubmittedSuccessfully: "ಸಂಗ್ರಹವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ!",
  collectionsSubmittedSuccessfully: "ಸಂಗ್ರಹಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ!",
  collectionForCustomerSubmitted: "{customer} ಅವರ ಸಂಗ್ರಹವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ!",
  customerIsRequired: "ಗ್ರಾಹಕ ಅಗತ್ಯವಿದೆ",
  fatPercentIsRequired: "ಕೊಬ್ಬಿನ ಶೇಕಡಾವಾರು ಅಗತ್ಯವಿದೆ",
  validFatPercentRequired: "ಮಾನ್ಯವಾದ ಕೊಬ್ಬಿನ ಶೇಕಡಾವಾರು ಅಗತ್ಯವಿದೆ",
  weightIsRequired: "ತೂಕ ಅಗತ್ಯವಿದೆ",
  validWeightRequired: "ಮಾನ್ಯವಾದ ತೂಕ ಅಗತ್ಯವಿದೆ",
  snfPercentIsRequired: "ಎಸ್ಎನ್‌ಎಫ್ ಶೇಕಡಾವಾರು ಅಗತ್ಯವಿದೆ",
  validSnfPercentRequired: "ಮಾನ್ಯವಾದ ಎಸ್ಎನ್‌ಎಫ್ ಶೇಕಡಾವಾರು ಅಗತ್ಯವಿದೆ",
  pleaseAddAtLeastOneCollection: "ದಯವಿಟ್ಟು ಕನಿಷ್ಠ ಒಂದು ಸಂಗ್ರಹವನ್ನು ಸೇರಿಸಿ",
  fromCLR: "ಸಿಎಲ್‌ಆರ್‌ನಿಂದ",
  noCustomersFound: "ಯಾವುದೇ ಗ್ರಾಹಕರು ಕಂಡುಬಂದಿಲ್ಲ",

  // Placeholders
  egTenPointFive: "ಉದಾ. 10.5",
  egThreePointFive: "ಉದಾ. 3.5",
  egTwentySevenPointZero: "ಉದಾ. 27.0",
  egEightPointFive: "ಉದಾ. 8.5",
  egFiftyFivePointZero: "ಉದಾ. 55.0",

  // Preview Collections filters and sorting
  searchCustomerOrId: "ಗ್ರಾಹಕರ ಹೆಸರು ಅಥವಾ ಐಡಿ ಮೂಲಕ ಹುಡುಕಿ",
  filterByCustomer: "ಸರಬರಾಜುದಾರರಿಂದ ಹುಡುಕಿ",
  filterByDate: "ದಿನಾಂಕದಿಂದ ಹುಡುಕಿ",
  filterByAnimal: "ಪ್ರಾಣಿಯಿಂದ ಫಿಲ್ಟರ್ ಮಾಡಿ",
  allAnimals: "ಎಲ್ಲಾ ಪ್ರಾಣಿಗಳು",
  newestFirst: "ಹೊಸದು ಮೊದಲು",
  oldestFirst: "ಹಳೆಯದು ಮೊದಲು",
  changeMilkRate: "ಹಾಲಿನ ದರ ಬದಲಾಯಿಸಿ",
  newMilkRate: "ಹೊಸ ಹಾಲು ದರ (₹/ಕೆಜಿ)",
  enterNewMilkRate: "ಹೊಸ ಹಾಲು ದರವನ್ನು ನಮೂದಿಸಿ",
  sortTooltipNewestFirst: "ರಚನೆಯ ಸಮಯದ ಪ್ರಕಾರ ಹೊಸದು ಮೊದಲು (ಹಳೆಯದು ಮೊದಲು ಮಾಡಲು ಬದಲಾಯಿಸಿ)",
  sortTooltipOldestFirst: "ರಚನೆಯ ಸಮಯದ ಪ್ರಕಾರ ಹಳೆಯದು ಮೊದಲು (ಹೊಸದು ಮೊದಲು ಮಾಡಲು ಬದಲಾಯಿಸಿ)",
  sortingLabel: "ವಿಂಗಡಣೆ:",
  sortingByCreationTime: "ರಚನೆಯ ಸಮಯದ ಪ್ರಕಾರ",

  // Additional translations for BulkCollectionV1
  lowWalletBalance: "ಕಡಿಮೆ ವಾಲೆಟ್ ಶೇಷ",
  walletBalanceLowMessage: "ನಿಮ್ಮ ವಾಲೆಟ್ ಶೇಷ ₹50 ಕ್ಕಿಂತ ಕಡಿಮೆಯಾಗಿದೆ. ನಿರಂತರ ಸೇವೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ವಾಲೆಟ್‌ಗೆ ಹಣವನ್ನು ಸೇರಿಸಿ.",
  currentBalance: "ಪ್ರಸ್ತುತ ಶೇಷ",
  dismiss: "ವಜಾಗೊಳಿಸಿ",

  // Pro Rata Collection specific translations

  // Rate Information
  // milkRate: "ಹಾಲಿನ ದರ (₹)",
  // fatSnf: "ಫ್ಯಾಟ್ + ಎಸ್‌ಎನ್‌ಎಫ್",
  // fatClr: "ಫ್ಯಾಟ್ + ಸಿಎಲ್‌ಆರ್",
  // litersOnly: "ಕೇವಲ ಲೀಟರ್‌ಗಳು",

  // Rate Configuration
  rateChart: "ದರ ಚಾರ್ಟ್",
  previewAndSubmit: "ಪೂರ್ವಾವಲೋಕನ ಮತ್ತು ಸಲ್ಲಿಸಿ",
  noDataYetClickAddRow: "ಇನ್ನೂ ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ. ಸಂಗ್ರಹಗಳನ್ನು ಸೇರಿಸಲು ಪ್ರಾರಂಭಿಸಲು \"ಸಾಲು ಸೇರಿಸಿ\" ಕ್ಲಿಕ್ ಮಾಡಿ.",

  // Customer Management
  addNewCustomer: "ಹೊಸ ಸಪ್ಲಯರ್ ಸೇರಿಸಿ",

  // Collection Form
  animalType: "ಪ್ರಾಣಿಯ ಪ್ರಕಾರ",
  mixed: "ಮಿಶ್ರಿತ",

  // Add Money Modal
  topUpWalletInstantly: "ರೇಜರ್‌ಪೇ ಬಳಸಿ ತಕ್ಷಣವೇ ನಿಮ್ಮ ವಾಲೆಟ್ ಟಾಪ್ ಅಪ್ ಮಾಡಿ",

  // Rate Chart Modal
  fatStepUpRates: "FAT ಸ್ಟೆಪ್-ಅಪ್ ದರಗಳು",
  snfStepDownRates: "SNF ಸ್ಟೆಪ್-ಡೌನ್ ದರಗಳು",
  rateAppliesWhenFatGreater: "FAT% ಸ್ಟೆಪ್‌ಗಿಂತ ಹೆಚ್ಚಾದಾಗ ಈ ದರ ಅನ್ವಯಿಸುತ್ತದೆ",
  rateAppliesWhenSnfLess: "SNF% ಸ್ಟೆಪ್‌ಗಿಂತ ಕಡಿಮೆಯಾದಾಗ ಈ ದರ ಅನ್ವಯಿಸುತ್ತದೆ",
  step: "ಸ್ಟೆಪ್ (%)",
  addStep: "ಸ್ಟೆಪ್ ಸೇರಿಸಿ",
  fatSnfRatio: "FAT/SNF ಅನುಪಾತ",

  // Change Rates Modal
  baseSNFSetting: "ಬೇಸ್ ಎಸ್‌ಎನ್‌ಎಫ್",
  clrConversionFactor: "ಸಿಎಲ್‌ಆರ್ ಪರಿವರ್ತನೆ ಅಂಶ",
  selectConversionFactor: "ಸಿಎಲ್‌ಆರ್ ನಿಂದ ಎಸ್‌ಎನ್‌ಎಫ್ ಸೂತ್ರದಲ್ಲಿ ಬಳಸುವ ಪರಿವರ್ತನೆ ಅಂಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ",

  // New Customer Modal
  newCustomer: "ಹೊಸ ಗ್ರಾಹಕ",

  // Messages and Alerts
  deleteConfirmation: "ನೀವು ನಿಜವಾಗಿಯೂ ಈ ಸಂಗ್ರಹವನ್ನು ಅಳಿಸಲು ಬಯಸುವಿರಾ?",
  confirmDelete: "ಅಳಿಸುವಿಕೆಯನ್ನು ದೃಢೀಕರಿಸಿ",
  pleaseAllowPopups: "ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಲು ದಯವಿಟ್ಟು ಪಾಪ್‌ಅಪ್‌ಗಳನ್ನು ಅನುಮತಿಸಿ.",
  paymentLinkOpened: "ಪಾವತಿ ಲಿಂಕ್ ಹೊಸ ಟ್ಯಾಬ್‌ನಲ್ಲಿ ತೆರೆಯಲಾಗಿದೆ. ಅಲ್ಲಿ ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಿ.",
  failedToCreatePaymentLink: "ಪಾವತಿ ಲಿಂಕ್ ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",

  // Bonus Messages
  bonusMessage5Percent: "ಈ ರೀಚಾರ್ಜ್‌ನಲ್ಲಿ ನೀವು ₹{amount} ಹೆಚ್ಚುವರಿ ಪಡೆಯುವಿರಿ!",
  bonusMessage10Percent: "ಈ ರೀಚಾರ್ಜ್‌ನಲ್ಲಿ ನೀವು ₹{amount} ಹೆಚ್ಚುವರಿ ಪಡೆಯುವಿರಿ!",

  // Validation Messages
  customerNameRequired: "ಗ್ರಾಹಕರ ಹೆಸರು ಅಗತ್ಯವಿದೆ",

  // Success Messages
  rateTypeUpdatedSuccessfully: "ದರ ಪ್ರಕಾರವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ!",
  newCustomerCreatedSuccessfully: "ಹೊಸ ಗ್ರಾಹಕ {name} ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ!",

  // Error Messages
  someCollectionsHaveInvalidData: "ಕೆಲವು ಸಂಗ್ರಹಗಳಲ್ಲಿ ಅಮಾನ್ಯ ಡೇಟಾ ಇದೆ. ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  failedToSubmitCollection: "{customer} ಗಾಗಿ ಸಂಗ್ರಹವನ್ನು ಸಲ್ಲಿಸಲು ವಿಫಲವಾಗಿದೆ: {error}",
  failedToUpdateMilkRate: "ಹಾಲಿನ ದರವನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  failedToUpdateRateType: "ದರ ಪ್ರಕಾರವನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  failedToCreateCustomer: "ಗ್ರಾಹಕರನ್ನು ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",

  // CLR Validation
  clrValueBelowMinimum: "ಸಿಎಲ್‌ಆರ್ ಮೌಲ್ಯ {value} ಕನಿಷ್ಠ (13.1) ಕ್ಕಿಂತ ಕಡಿಮೆಯಾಗಿದೆ",
  clrValueAboveMaximum: "ಸಿಎಲ್‌ಆರ್ ಮೌಲ್ಯ {value} ಗರಿಷ್ಠ (34.0) ಕ್ಕಿಂತ ಹೆಚ್ಚಾಗಿದೆ",

  // Warning Messages
  warningFatPercentBelowMin: "ಎಚ್ಚರಿಕೆ: ಕೊಬ್ಬು % ಕನಿಷ್ಠ {min}% ಕ್ಕಿಂತ ಕಡಿಮೆ",
  warningFatPercentAboveMax: "ಎಚ್ಚರಿಕೆ: ಕೊಬ್ಬು % {max}% ಗಿಂತ ಹೆಚ್ಚು",
  warningSnfPercentBelowMin: "ಎಚ್ಚರಿಕೆ: ಎಸ್ಎನ್‌ಎಫ್ % ಕನಿಷ್ಠ {min}% ಕ್ಕಿಂತ ಕಡಿಮೆ",
  warningSnfPercentAboveMax: "ಎಚ್ಚರಿಕೆ: ಎಸ್ಎನ್‌ಎಫ್ % {max}% ಗಿಂತ ಹೆಚ್ಚು",
  warningClrBelowMin: "ಎಚ್ಚರಿಕೆ: ಸಿಎಲ್‌ಆರ್ ಮೌಲ್ಯ {min} ಕ್ಕಿಂತ ಕಡಿಮೆ",
  warningClrAboveMax: "ಎಚ್ಚರಿಕೆ: ಸಿಎಲ್‌ಆರ್ ಮೌಲ್ಯ {max} ಗಿಂತ ಹೆಚ್ಚು",
  warningFatPercentBelowMinRaw: "ಎಚ್ಚರಿಕೆ: ಕೊಬ್ಬಿನ ಶೇಕಡಾವಾರು {min}% ಕ್ಕಿಂತ ಕಡಿಮೆ",
  warningFatPercentAboveMaxRaw: "ಎಚ್ಚರಿಕೆ: ಕೊಬ್ಬಿನ ಶೇಕಡಾವಾರು {max}% ಗಿಂತ ಹೆಚ್ಚು",
  warningSnfPercentBelowMinRaw: "ಎಚ್ಚರಿಕೆ: ಎಸ್ಎನ್‌ಎಫ್ ಶೇಕಡಾವಾರು {min}% ಕ್ಕಿಂತ ಕಡಿಮೆ",
  warningSnfPercentAboveMaxRaw: "ಎಚ್ಚರಿಕೆ: ಎಸ್ಎನ್‌ಎಫ್ ಶೇಕಡಾವಾರು {max}% ಗಿಂತ ಹೆಚ್ಚು",

  // Confirmation Messages
  confirmDeletion: "ಅಳಿಸುವಿಕೆಯನ್ನು ದೃಢೀಕರಿಸಿ",
  areYouSureDeleteRow: "ನೀವು ನಿಜವಾಗಿಯೂ ಈ ಸಾಲನ್ನು ಅಳಿಸಲು ಬಯಸುವಿರಾ?",
  actionCannotBeUndone: "ಈ ಕ್ರಿಯೆಯನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುವುದಿಲ್ಲ.",
  thisBulkUpdateCannotBeUndone: "ಈ ಕ್ರಿಯೆಯನ್ನು ಹಿಂದಿರುಗಿಸಲಾಗುವುದಿಲ್ಲ.",
  thisActionCannotBeUndone: "ಎಚ್ಚರಿಕೆ: ಈ ಕ್ರಿಯೆ ಶಾಶ್ವತವಾಗಿದ್ದು, ಇದನ್ನು ಹಿಂತಿರುಗಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ.",
  deleteThisRow: "ಈ ಸಾಲನ್ನು ಅಳಿಸಿ",
  deleteCollectionRow: "ಸಂಗ್ರಹ ಸಾಲನ್ನು ಅಳಿಸಿ",
  rowWillBePermanentlyDeleted: "ಈ ಸಾಲಿನಲ್ಲಿ ಡೇಟಾ ಇದೆ ಅದು ಶಾಶ್ವತವಾಗಿ ಅಳಿಸಲ್ಪಡುತ್ತದೆ",
  areYouSureProceedDeletion: "ನೀವು ನಿಜವಾಗಿಯೂ ಅಳಿಸುವಿಕೆಯೊಂದಿಗೆ ಮುಂದುವರೆಯಲು ಬಯಸುವಿರಾ?",

  // Low Percentage Warning
  lowPercentageValue: "ಕಡಿಮೆ ಶೇಕಡಾವಾರು ಮೌಲ್ಯ",
  enteredValueLessThan: "ನೀವು {field} ಗಾಗಿ {min}% ಗಿಂತ ಕಡಿಮೆ ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿದ್ದೀರಿ",
  enteredProcessed: "ನಮೂದಿಸಿದ: {entered} → ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿದ: {processed}%",
  areYouSureProceedValue: "ನೀವು ನಿಜವಾಗಿಯೂ ಈ ಮೌಲ್ಯದೊಂದಿಗೆ ಮುಂದುವರೆಯಲು ಬಯಸುವಿರಾ?",

  // Preview Modal
  previewCollections: "ಸಂಗ್ರಹಗಳ ಮುನ್ನೋಟ",
  pleaseReviewBeforeSubmit: "ದಯವಿಟ್ಟು ಸಲ್ಲಿಸುವ ಮೊದಲು ಕೆಳಗಿನ ಸಂಗ್ರಹಗಳನ್ನು ಪರಿಶೀಲಿಸಿ:",
  pleaseReviewBeforeSave: "ದಯವಿಟ್ಟು ಉಳಿಸುವ ಮೊದಲು ಸಂಪಾದಿಸಿದ ಸಂಗ್ರಹವನ್ನು ಪರಿಶೀಲಿಸಿ:",
  totalWeight: "ಒಟ್ಟು ತೂಕ:",
  totalRecords: "ಒಟ್ಟು ದಾಖಲೆಗಳು:",
  confirmSubmit: "ದೃಢೀಕರಿಸಿ ಮತ್ತು ಸಲ್ಲಿಸಿ",

  // Add Money Modal
  offers: "ಆಫರ್‌ಗಳು",
  getExtraBonus: "ರೀಚಾರ್ಜ್‌ನಲ್ಲಿ ಹೆಚ್ಚುವರಿ ಬೋನಸ್ ಪಡೆಯಿರಿ",

  // New Customer Modal
  pleaseFillCustomerDetails: "ದಯವಿಟ್ಟು ಗ್ರಾಹಕ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ. * ಎಂದು ಗುರುತಿಸಿದ ಕ್ಷೇತ್ರಗಳು ಅಗತ್ಯವಿದೆ.",
  createCustomer: "ಗ್ರಾಹಕರನ್ನು ರಚಿಸಿ",
  savingCustomer: "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",

  // Preview Collections Modals
  confirmDeleteCollection: "ಅಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ",
  areYouSureDeleteCollection: "ನೀವು ಈ ಸಂಗ್ರಹವನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
  deleting: "ಅಳಿಸಲಾಗುತ್ತಿದೆ...",
  deleteSuccess: "ಸಂಗ್ರಹಣೆ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲ್ಪಟ್ಟಿದೆ",
  collectionDeletedSuccessfully: "ಸಂಗ್ರಹಣೆ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲ್ಪಟ್ಟಿದೆ!",
  deleteFailed: "ಸಂಗ್ರಹಣೆಯನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  loadCollectionsFailed: "ಸಂಗ್ರಹಣೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  loadCustomersFailed: "ಗ್ರಾಹಕರನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  pleaseSelectBothDates: "ದಯವಿಟ್ಟು ಎರಡೂ ದಿನಾಂಕಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  toDateCannotBeEarlier: "ನಿಂದ ದಿನಾಂಕಕ್ಕಿಂತ ಮುಂಚಿನ ದಿನಾಂಕವಾಗಿರಬಾರದು",

  // Bulk Update Modal
  bulkUpdateRateBaseSnf: "ಹಾಲು ಮತ್ತು ಬೇಸ್ SNF ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  updatingCollections: "{count} ಸಂಗ್ರಹಣೆಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗುತ್ತಿದೆ",
  dateRange: "ದಿನಾಂಕ ಶ್ರೇಣಿ",
  allDates: "ಎಲ್ಲಾ ದಿನಾಂಕಗಳು",
  newMilkRatePerKg: "ಹೊಸ ಹಾಲಿನ ದರ (₹/ಕೆಜಿ):",
  newBaseSnfPercent: "ಹೊಸ ಬೇಸ್ SNF (%):",
  updateCollections: "ಸಂಗ್ರಹಣೆಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  updating: "ಅಪ್‌ಡೇಟ್ ಆಗುತ್ತಿದೆ...",

  // Milk Rate Preview Modal
  previewMilkRateCalculations: "ಹಾಲಿನ ದರ ಲೆಕ್ಕಾಚಾರದ ಪೂರ್ವವೀಕ್ಷಣೆ",
  collectionsOnDate: "{date} ರಂದಿನ ಸಂಗ್ರಹಣೆಗಳು",
  collectionsFromToDate: "{fromDate} ರಿಂದ {toDate} ವರೆಗಿನ ಸಂಗ್ರಹಣೆಗಳು",
  dateAndTime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
  baseSnfPercent: "ಬೇಸ್ SNF",
  milkRateLabel: "ಹಾಲಿನ ದರ",


  bulkUpdateRateAndBaseSNF: "ಹಾಲು ಮತ್ತು SNF ಬದಲಿಸಿ",


  // Filter Modal
  filterCollectionsMilkRateUpdate: "ಹಾಲಿನ ದರ ಅಪ್‌ಡೇಟ್‌ಗಾಗಿ ಸಂಗ್ರಹಣೆಗಳನ್ನು ಫಿಲ್ಟರ್ ಮಾಡಿ",
  dateRangeLabel: "ದಿನಾಂಕ ಶ್ರೇಣಿ",

  // Customer Selection Modal
  searchCustomers: "ಗ್ರಾಹಕರನ್ನು ಹುಡುಕಿ...",

  // Bulk Update Confirmation Modal
  confirmBulkUpdate: "ಬಲ್ಕ್ ಅಪ್‌ಡೇಟ್ ದೃಢೀಕರಿಸಿ",
  areYouSureApplyBulkChanges: "ಈ ಬಲ್ಕ್ ಬದಲಾವಣೆಗಳನ್ನು ಅನ್ವಯಿಸಲು ನೀವು ಖಚಿತವಾಗಿದ್ದೀರಾ?",
  collectionsToUpdate: "ಅಪ್‌ಡೇಟ್ ಮಾಡಬೇಕಾದ ಸಂಗ್ರಹಗಳು",
  newBaseSnf: "ಹೊಸ ಬೇಸ್ SNF",
  newSnfPercentage: "ಹೊಸ SNF ಶೇಕಡಾ",
  newClr: "ಹೊಸ CLR",
  updatingCollectionsCount: "{count} ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗುತ್ತಿದೆ",
  currentAmount: "ಪ್ರಸ್ತುತ ಮೊತ್ತ",
  newRate: "ಹೊಸ ದರ",
  newAmount: "ಹೊಸ ಮೊತ್ತ",
  confirmAndUpdate: "ದೃಢೀಕರಿಸಿ ಮತ್ತು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  // Final Submit Confirmation Modal
  importantConfirmation: "ಮುಖ್ಯ ದೃಢೀಕರಣ",
  irreversibleChangesWarning: "ಮರಳಿ ಬರದ ಬದಲಾವಣೆ ಎಚ್ಚರಿಕೆ",
  pleaseBeAware: "ದಯವಿಟ್ಟು ತಿಳಿದುಕೊಳ್ಳಿ:",
  irreversibleChangesWarningText: "ಒಮ್ಮೆ ನೀವು ಸಬ್ಮಿಟ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿದ ನಂತರ, ಈ ಬದಲಾವಣೆಗಳನ್ನು ಹಿಂದಿನ ಸ್ಥಿತಿಗೆ ಹಿಂದಿರುಗಿಸಲಾಗುವುದಿಲ್ಲ. ಎಲ್ಲಾ ಪ್ರಭಾವಿತ ಸಂಗ್ರಹಗಳು ಹೊಸ ಮೌಲ್ಯಗಳೊಂದಿಗೆ ಶಾಶ್ವತವಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗುತ್ತದೆ.",
  areYouAbsolutelySureYouWantToProceed: "ನೀವು ಖಂಡಿತವಾಗಿ ಮುಂದುವರಿಯಲು ಬಯಸುವಿರಾ?",
  submitChanges: "ಬದಲಾವಣೆಗಳನ್ನು ಸಬ್ಮಿಟ್ ಮಾಡಿ",

  // Report Types
  fullReport: "ಸಂಪೂರ್ಣ ವರದಿ",
  purchaseReportDayWise: "ಖರೀದಿ ವರದಿ - ದಿನದ ಪ್ರಕಾರ",
  purchaseSummarySupplierWise: "ಖರೀದಿ ಸಾರಾಂಶ - ಪೂರೈಕೆದಾರರ ಪ್ರಕಾರ",
  allSupplierBill: "ಎಲ್ಲಾ ಪೂರೈಕೆದಾರ ಬಿಲ್",
  supplierBillsPro: "ಪೂರೈಕೆದಾರ ಬಿಲ್ (ಪ್ರೋ-ರಾಟಾ)",
  supplierBills: "ಪೂರೈಕೆದಾರ ಬಿಲ್ ",

  fullReportPro: "ಸಂಪೂರ್ಣ ವರದಿ (ಪ್ರೋ-ರಾಟಾ)",
  purchaseReportDayWisePro: "ಖರೀದಿ ವರದಿ - ದಿನದ ಪ್ರಕಾರ (ಪ್ರೋ-ರಾಟಾ)",
  purchaseSummarySupplierWisePro: "ಖರೀದಿ ಸಾರಾಂಶ - ಪೂರೈಕೆದಾರರ ಪ್ರಕಾರ (ಪ್ರೋ-ರಾಟಾ)",
  allSupplierBillPro: "ಎಲ್ಲಾ ಪೂರೈಕೆದಾರ ಬಿಲ್ (ಪ್ರೋ-ರಾಟಾ)",
  supplierBillsPro: "ಪೂರೈಕೆದಾರ ಬಿಲ್ (ಪ್ರೋ-ರಾಟಾ)",
  viewCompleteCollectionReport: "ಸಂಪೂರ್ಣ ಸಂಗ್ರಹಣೆ ವರದಿಯನ್ನು ವೀಕ್ಷಿಸಿ",
  viewCollectionsByDate: "ದಿನಾಂಕದ ಪ್ರಕಾರ ಸಂಗ್ರಹಣೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
  viewCollectionsAsPerSupplier: "ಪೂರೈಕೆದಾರರ ಪ್ರಕಾರ ಸಂಗ್ರಹಣೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
  viewComprehensiveSupplierBills: "ವ್ಯಾಪಕ ಪೂರೈಕೆದಾರ ಬಿಲ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
  viewIndividualSupplierBills: "ಪ್ರತ್ಯೇಕ ಪೂರೈಕೆದಾರ ಬಿಲ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ",

  // Additional Labels
  fromDate: "ಪ್ರಾರಂಭ ದಿನಾಂಕ",
  toDate: "ಅಂತಿಮ ದಿನಾಂಕ",
  selectReportType: "ವರದಿ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  selectReportTypeProRata: "ವರದಿ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ (ಪ್ರೋ-ರಾಟಾ)",
  generateReport: "ವರದಿಯನ್ನು ರಚಿಸಿ",
  generating: "ರಚಿಸಲಾಗುತ್ತಿದೆ...",
  pleaseSelectBothStartAndEndDates: "ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ಮತ್ತು ಅಂತಿಮ ಎರಡೂ ದಿನಾಂಕಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  invalidReportTypeSelected: "ಅಮಾನ್ಯವಾದ ವರದಿ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
  failedToGenerateReport: "ವರದಿಯನ್ನು ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ",
  failedToLoadSuppliers: "ಪೂರೈಕೆದಾರರನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
  failedToUpdateSupplierInformation: "ಪೂರೈಕೆದಾರ ಮಾಹಿತಿಯನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
  pleaseSelectDateRangeForReport: "ವರದಿಗಾಗಿ ದಿನಾಂಕ ಶ್ರೇಣಿಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  noDataFoundForTheSelectedSupplierInTheSelectedDateRange: "ಆಯ್ಕೆ ಮಾಡಿದ ದಿನಾಂಕ ಶ್ರೇಣಿಯಲ್ಲಿ ಆಯ್ಕೆ ಮಾಡಿದ ಪೂರೈಕೆದಾರರಿಗೆ ಯಾವುದೇ ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
  failedToGenerateSupplierReport: "ಪೂರೈಕೆದಾರ ವರದಿಯನ್ನು ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ",
  pleaseEnterAtLeastMilkRateSnfOrClrToUpdate: "ದಯವಿಟ್ಟು ಕನಿಷ್ಠ ಹಾಲಿನ ದರ, SNF ಪ್ರತಿಶತ, ಅಥವಾ CLR ಅನ್ನು ನಮೂದಿಸಿ",
  failedToGenerateProRataSupplierReport: "ಪ್ರೋ-ರಾಟಾ ಪೂರೈಕೆದಾರ ವರದಿಯನ್ನು ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ",

  // Month Names
  january: "ಜನವರಿ",
  february: "ಫೆಬ್ರವರಿ",
  march: "ಮಾರ್ಚ್",
  april: "ಏಪ್ರಿಲ್",
  may: "ಮೇ",
  june: "ಜೂನ್",
  july: "ಜುಲೈ",
  august: "ಆಗಸ್ಟ್",
  september: "ಸೆಪ್ಟೆಂಬರ್",
  october: "ಅಕ್ಟೋಬರ್",
  november: "ನವೆಂಬರ್",
  december: "ಡಿಸೆಂಬರ್",

  // Additional missing keys
  selectSupplierPro: "ಪೂರೈಕೆದಾರರನ್ನು ಆಯ್ಕೆ ಮಾಡಿ (ಪ್ರೋ-ರಾಟಾ)",
  selectSupplier: "ಪೂರೈಕೆದಾರರನ್ನು ಆಯ್ಕೆ ಮಾಡಿ ",

  supplierInformation: "ಪೂರೈಕೆದಾರರ ಮಾಹಿತಿ",
  includeMilkRateBRateColumn: "ಹಾಲಿನ ದರ (ಬಿ-ರೇಟ್) ಕಾಲಮ್ ಸೇರಿಸಿ",
  backToReportSelection: "ವರದಿ ಆಯ್ಕೆಗೆ ಹಿಂದಿರಿಗೆ ಹೋಗಿ",
  saveChanges: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
  editSupplier: "ಸರಬರಾಜುದಾರ",
  loadingSuppliers: "ಪೂರೈಕೆದಾರರು ಲೋಡ್ ಆಗುತ್ತಿದ್ದಾರೆ...",
  databaseId: "ಡೇಟಾಬೇಸ್ ಐಡಿ",
  customerId: "ಗ್ರಾಹಕ ಐಡಿ",
  notSpecified: "ನಿರ್ದಿಷ್ಟಿಸಲಿಲ್ಲ",
  id: "ಐಡಿ",

  // Warning and Success Messages
  milkRateUpdatedSuccessfully: "ಹಾಲಿನ ದರ ಸಫಲತಾಪೂರವಕ ಅಪ್‌ಡೇಟ್ ಆಯಿತಗೊಂಡೆ!",
  errorSavingMilkRatePleaseTryAgain: "ಹಾಲಿನ ದರ ಉಳಿಸುವುದಲು ದೋಷ ಆಯಿತಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  rateSettingsSavedSuccessfully: "ದರ ಸೆಟ್ಟಿ೰ಗ್ಸ ಸಫಲತಾಪೂರವಕ ಉಳಿಸಿ!",
  errorSavingMilkRateAndRateSettingsPleaseTryAgain: "ಹಾಲಿನ ದರ ಮತ್ತು ದರ ಸೆಟ್ಟಿ೰ಗ್ಸ ಉಳಿಸುವುದಲು ದೋಷ ಆಯಿತಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  rateChartLoadedSuccessfully: "ದರ ಚಾರ್ಟ್ ಸಫಲತಾಪೂರವಕ ಲೋಡ್ ಆಯಿತಗೊಂಡೆ",
  paymentLinkOpenedInNewTabCompletePaymentThere: "ಪಾವೆಮೆಂಟ್ ಲಿ೰ಕ್ ಹೊಸ ಟ್ಯಾಬ್ 'ಚ್ ತೆರೆಯಲಾ. ಅಲ್ಲೆ ಪಾವೆಮೆಂಟ್ ಪೂರ್ತಿಸಿ.",
  paymentSuccessfulYourWalletWillBeUpdatedShortly: "✅ ಪಾವೆಮೆಂಟ್ ಸಫಲ! ನಿಮ್ಮ ವ್ಯಾಲೆಟ್ ಶೀಘ್ರಲಿ ಅಪ್ಡೇಟ್ ಆಗುತ್ದಾರೆ.",
  individualMilkRateSavedSuccessfullyProRataCollection: "ವಿಶೇಷಗತ ಹಾಲಿನ ದರ ಸಫಲತಾಪೂರವಕ ಅಪ್‌ಡೇಟ್ ಆಯಿತಗೊಂಡೆ (ಪ್ರೋ-ರಾಟಾ ಕಲೆಕ್ಸ಼ನ)",
  walletBalanceBelowFifty: "ನಿಮ್ಮ ವ್ಯಾಲೆಟ್‌ನಲ್ಲಿ ₹50 ಕ್ಕಿಂತ ಕಡಿಮೆ ಹಣ ಉಳಿದಿದೆ. ಯಾವುದೇ ಸೇವೆ ಅಡಚಣೆಯನ್ನು ತಪ್ಪಿಸಲು ದಯವಿಟ್ಟು ತಕ್ಷಣ ಹಣವನ್ನು ಸೇರಿಸಿ.",
  closeAddMoneyModal: "ಹಣ ಸೇರಿಸುವ ಮೋಡಲ್ ಅಟ್ಟಿಸಿ",

  // Milk Rate Preview Modal
  bulkEditCollections: "ಬಲ್ಕ ಸಂಪಾದನೆ ಸಂಗ್ರಹಗಳು",
  collectionsOn: "ಸಂಗ್ರಹಗಳು ದಿನಾಂಕ",
  collectionsFromTo: "ಸಂಗ್ರಹಗಳು {fromDate} ರಿಂದ {toDate} ವರೆಗೆ",
  items: "ಐಟಂಗಳು",
  mix: "ಮಿಶ್ರಣ",
  weightKg: "ತೂಕ (ಕೆಜಿ)",
  fat: "Fat",
  snf: "SNF",
  solid: "ಘನ",
  totalAmt: "ಒಟ್ಟು ಮೊತ್ತ",
  finalAmt: "ಅಂತಿಮ ಮೊತ್ತ",
  collectionSummary: "ಸಂಗ್ರಹ ಸಾರಾಂಶ",
  applyBulkChanges: "ಬಲ್ಕ ಬದಲಾವಣೆಗಳನ್ನು ಅನ್ವಯಯಿಸಿ",

  // Milk Rate Date Selection Modal
  singleDate: "ಏಕ ದಿನಾಂಕ",
  selectDate: "ದಿನಾಂಕ ಆಯ್ಕೆ ಮಾಡಿ:",

  // New Customer Modal
  fathersName: "ತಂದೆಯ ಹೆಸರು",
  enterFathersName: "ತಂದೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  enter10DigitPhoneNumber: "10 ಅಂಕಿಗಳ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",

  // Rate Settings Card
  configureYourMilkCalculationParameters: "ನಿಮ್ಮ ಹಾಲಿನ ಲೆಕ್ಕಾಚಿ ಪ್ಯಾರಾಮೀಟರ್‌ಗಳನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಿ",
  clrConversion: "CLR ಪರಿವರ್ತನೆ",
  fatAndSNF: "Fat & SNF",
  fixedRate: "ನಿರ್ಧಾರಿತ ದರ",

  // Dairy & Owner Information Card
  dairyAndOwnerInfo: "ಹಾಲು ಕೇಂದ್ರ ಮತ್ತು ಮಾಲೀಕರ ಮಾಹಿತಿ",
  yourDairyAndContactDetails: "ನಿಮ್ಮ ಹಾಲು ಕೇಂದ್ರ ಮತ್ತು ಸಂಪರ್ಕ ವಿವರಗಳು",
  ownerName: "ಮಾಲೀಕರ ಹೆಸರು",
  // editSupplier: "ಪೂರೈಕೆದಾರರನ್ನು ಸಂಪಾದಿಸಿ",

  // Pro Rata Collection Component
  proRata: "ಪ್ರೋ ರಾಟಾ",
  set: "ಸೆಟ್ ಮಾಡಿ",
  status: "ಸ್ಥಿತಿ",
  setTheRateChart: "ರೇಟ್ ಚಾರ್ಟ್ ಸೆಟ್ ಮಾಡಿ",
  fatStepUp: "Fat ಸ್ಟೆಪ್-ಅಪ್",
  snfStepDown: "SNF ಸ್ಟೆಪ್-ಡೌನ್",
  notConfigured: "ಕಾನ್ಫಿಗರ್ ಮಾಡಿಲಿಲ್ಲ",
  proRataStatus: "ಪ್ರೋ-ರಾಟಾ ಸ್ಥಿತಿ",
  active: "ಸಕ್ರಿಯ",
  rateChartRequired: "ರೇಟ್ ಚಾರ್ಟ್ ಅಗತ್ಯ",
  pleaseSetUpYourRateChartFirst: "ದಯವಿಟ್ಟು ಸಂಗ್ರಹಗಳನ್ನು ಸೇರಿಸುವ ಮೊದಲು ನಿಮ್ಮ ರೇಟ್ ಚಾರ್ಟ್ ಅನ್ನು ಸೆಟ್ ಮಾಡಿ. ಇದು ಸರಿಯಾದ ಪ್ರೋ-ರಾಟಾ ಲೆಕ್ಕಾಚಿಗಳಿಗೆ ಅಗತ್ಯವಾಗಿದೆ.",
  setUpRateChart: "ರೇಟ್ ಚಾರ್ಟ್ ಸೆಟ್ ಮಾಡಿ",

  // Edit Collection Modal Labels
  editCollection: "ಸಂಗ್ರಹವನ್ನು ಸಂಪಾದಿಸಿ",
  supplier: "ಪೂರೈಕೆದಾರ",
  select: "ಆಯ್ಕೆ ಮಾಡಿ",
  previewChanges: "ಬದಲಾವಣೆಗಳನ್ನು ನೋಡಿ",
  backToEdit: "ಸಂಪಾದನೆಗೆ ಹಿಂದಿರುಗು",
  confirmSave: "ಪುಷ್ಟಿಸಿ ಮತ್ತು ಉಳಿಸಿ",

  // Edit Supplier Modal
  // editSupplier: "ಪೂರೈಕೆದಾರರನ್ನು ಸಂಪಾದಿಸಿ",
  searchSuppliers: "ಪೂರೈಕೆದಾರರನ್ನು ಹುಡುಕಿ...",
  noSuppliersFound: "ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಹೊಂದಿಕೊಳ್ಳುವ ಯಾವುದೇ ಪೂರೈಕೆದಾರರು ಸಿಗಲಿಲ್ಲ.",
  typeToSearchSuppliers: "ಪೂರೈಕೆದಾರರನ್ನು ಹುಡುಕಲು ಟೈಪ್ ಮಾಡಿ...",
  nameRequired: "ಹೆಸರು *",
  backToList: "ಪಟ್ಟಿಗೆ ಹಿಂದಿರುಗಿ",
  updateSupplier: "ಪೂರೈಕೆದಾರರನ್ನು ಅಪ್ಡೇಟ್ ಮಾಡಿ",

  // Preview Collections Modal
  pleaseReviewCollections: "ಸಲ್ಲಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ಕೆಳಗಿನ ಸಂಗ್ರಹಗಳನ್ನು ವಿಮರ್ಶಿಸಿ:",
  confirmAndSubmit: "ದೃಢೀಕರಿಸಿ ಮತ್ತು ಸಲ್ಲಿಸಿ",

  // Customer Filter Modal
  searchSuppliersPlaceholder: "ಪೂರೈಕೆದಾರರನ್ನು ಹುಡುಕಿ...",

  // Bulk Update Rate & SNF
  bulkUpdateRateAndSnf: "ಹಾಲು ಮತ್ತು ಬೇಸ್ SNF ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  enterNewBaseSnf: "ಹೊಸ ಬೇಸ್ SNF ದರ್ಜ ಕರೋ",

  areYouSureUpdateCollections: "ನೀವು ಈ {count} ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ಖಚಿತವಾಗಿದ್ದೀರಾ?",

  // Supplier Details Modal
  supplierID: "ಪೂರೈಕೆದಾರ ID",
  customerID: "ಗ್ರಾಹಕ ID",
  editSupplierInfo: "ಪೂರೈಕೆದಾರರ ಮಾಹಿತಿಯನ್ನು ಸಂಪಾದಿಸಿ",
  downloadReport: "ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  proRataCollectionsModal: "ಪ್ರೋ ರಾಟಾ ಸಂಗ್ರಹಗಳು",
  rechargeBonusMessage: "ಈ ರಿಚಾರ್ಜ್‌ನಲ್ಲಿ ನೀವು ₹100.00 ಹೆಚ್ಚುವರಿ ಪಡೆಯುತ್ತೀರಿ!",
  rechargeBonusMessage10Percent: "ಈ ರಿಚಾರ್ಜ್‌ನಲ್ಲಿ ನೀವು ₹{amount} ಹೆಚ್ಚುವರಿ ಪಡೆಯುತ್ತೀರಿ!",
  rechargeBonusMessage5Percent: "ಈ ರಿಚಾರ್ಜ್‌ನಲ್ಲಿ ನೀವು ₹{amount} ಹೆಚ್ಚುವರಿ ಪಡೆಯುತ್ತೀರಿ!",
  // Percentage Confirmation Modal
  highPercentageValue: "ಅಧಿಕ ಪ್ರತೀಶತ ಮೌಲ್ಯ",
  enteredValueGreaterThan: "ನೀವು {field} ಮೌಲ್ಯ {max}% ಗಿಂತ ಅಧಿಕ",
  noChangeValue: "ಇಲ್ಲ, ಮೌಲ್ಯ ಬದಲಿ",
  yesKeepValue: "ಹಾಗು, ಮೌಲ್ಯ ರಖೋ",
  // Submission Loading Overlay
  submittingCollectionsToServer: "ಸರ್ವರ್‌ಗೆ ಸಂಗ್ರಹಗಳನ್ನು ಜಮಾ ಕರುತ್ತಿದೆ...",
  progress: "ಪ್ರಗತಿ: {progress} ರಿಂದ {total} ಸಂಗ್ರಹಗಳು",
  // Customer Dropdown and Table Headers
  shift: "ಶಿಫ್ಟ್",
  litersOnly: "ಲೀಟರ್ಸ್",
  animal: "ಪ್ರಾಣಿ",
  apply: "ಅನ್ವಯಿಸು",

  // Active Filters Summary
  activeFilters: "ಸಕ್ರಿಯ ಫಿಲ್ಟರ್‌ಗಳು:",
  showingCollectionsFor: "{name} ಗಾಗಿ ಸಂಗ್ರಹಗಳನ್ನು ತೋರಿಸುತ್ತಿದೆ",
  showingCollectionsForOn: "{name} ಗಾಗಿ {date} ರಂದು ಸಂಗ್ರಹಗಳನ್ನು ತೋರಿಸುತ್ತಿದೆ",
  showingCollectionsForFromTo: "{name} ಗಾಗಿ {fromDate} ರಿಂದ {toDate} ರವರೆಗೆ ಸಂಗ್ರಹಗಳನ್ನು ತೋರಿಸುತ್ತಿದೆ",
  showingAllCollectionsOn: "ಎಲ್ಲಾ ಸಂಗ್ರಹಗಳು {date} ರಂದು ತೋರಿಸುತ್ತಿದೆ",
  showingAllCollectionsFromTo: "ಎಲ್ಲಾ ಸಂಗ್ರಹಗಳು {fromDate} ರಿಂದ {toDate} ರವರೆಗೆ ತೋರಿಸುತ್ತಿದೆ",
  sorting: "ವಿಂಗಡಣೆ:",
  byCreationTime: "ರಚನೆಯ ಸಮಯದ ಪ್ರಕಾರ",
  clearSupplier: "ಪೂರೈಕೆದಾರವನ್ನು ತೆಗೆದುಹಾಕಿ",
  clearDates: "ದಿನಾಂಕಗಳನ್ನು ತೆಗೆದುಹಾಕಿ",
  // Customer Search Dropdown
  searchSupplier: "ಪೂರೈಕೆದಾರರನ್ ಹುಡುತ್ತಿ...",
  noSupplierFound: "ಯಾವು ಪೂರೈಕೆದಾರರು ಸಿಲಿಲ್ಲಿಲ್ಲ",
  addNewSupplier: "ಹೊಸ ಪೂರೈಕೆದಾರರನ್ನ್ನು",
  selectCustomer: "ಗ್ರಾಹಕರನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",

  // Offers Modal
  starterBonusRange: "₹500 - ₹999",
  premiumBonusRange: "₹1000+",
  getExtraBonusOnRecharge: "ರೇಚಾರ್ಜ್‌ನಲ್ಲಿ ಹೆಚ್ಚುವರಿ ಬೋನಸ್ ಪಡೆಯಿರಿ",
  getExtra5PercentBonus: "ಹೆಚ್ಚುವರಿ 5% ಬೋನಸ್ ಪಡೆಯಿರಿ",
  addBetween500And999: "₹500 - ₹999 ರೇಚಾರ್ಜ್‌ನಲ್ಲಿ",
  getExtra10PercentBonus: "ಹೆಚ್ಚುವರಿ 10% ಬೋನಸ್ ಪಡೆಯಿರಿ",
  add1000OrMore: "₹1000 ಅಥವಾ ಅದಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ರೇಚಾರ್ಜ್‌ನಲ್ಲಿ",

  // Support Modal
  contactSupport: "ಸಂಪರ್ಕ ಬೆಂಬಲ",
  whatsappSupport: "ವಾಟ್ಸಾಪ್ ಬೆಂಬಲ",
  callSupport: "ಕರೆ ಬೆಂಬಲ",
  supportNumber: "+91 7454 860 294",

  // Bulk Collection Support Section
  havingTroubleAddingMoney: "ಹಣ ಸೇರಿಸುವಲ್ಲಿ ತೊಂದರೆ ಆಗುತ್ತಿದೆಯೇ?",
  contactUs: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

  // Offers Support Section
  needHelpWithOffers: "ಆಫರ್‌ಗಳ ಬಗ್ಗೆ ಸಹಾಯ ಬೇಕೇ?",

  // Navbar Support Button
  support: "ಬೆಂಬಲ",

  // Toast Messages for Pro-Rata Collections
  collectionUpdatedSuccessfully: "ಸಂಗ್ರಹವು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ!",
  updatedProRataCollectionsWithMilkRate: "{successful} ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹಗಳು ಹಾಲಿನ ದರದೊಂದಿಗೆ ನವೀಕರಿಸಲಾಗಿದೆ. {failed} ಸಂಗ್ರಹಗಳನ್ನು ನವೀಕರಿಸಲು ವಿಫಲವಾಗಿದೆ.",
  successfullyUpdatedProRataCollectionsWithMilkRate: "{count} ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹಗಳು ಹಾಲಿನ ದರ {rate} ಯೊಂದಿಗೆ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ.",
  successfullyUpdatedProRataCollections: "{count} ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹಗಳು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ.",
  noProRataCollectionsFoundToUpdate: "ನವೀಕರಿಸಲು ಯಾವುದೇ ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
  failedToApplyMilkRatesAndBaseSnf: "ಹಾಲಿನ ದರಗಳು ಮತ್ತು ಬೇಸ್ SNF ಅನ್ವಯಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",

  // Validation Error Messages
  collectionDateRequired: "ಸಂಗ್ರಹ ದಿನಾಂಕ ಅಗತ್ಯವಿರುವದು",
  fatPercentRequired: "ಕೊಬ್ಬು ಪ್ರತಿಶತ ಅಗತ್ಯವಿರುವದು",
  weightRequired: "ತೂಕ ಅಗತ್ಯವಿರುವದು",
  snfPercentRequired: "SNF ಪ್ರತಿಶತ ಅಗತ್ಯವಿರುವದು",
  snfPercentCannotExceed15: "SNF ಪ್ರತಿಶತ 15% ಗಿಂತ ಹೆಚ್ಚಿರಬಾರದು",
  validClrRequired: "ಮಾನ್ಯವಾದ CLR ಅಗತ್ಯವಿರುವದು",
  clrValueInvalid: "CLR ಮೌಲ್ಯ \"{value}\" ಅಮಾನ್ಯವಾಗಿದೆ. ಕನಿಷ್ಠ 2 ಅಂಕಿಗಳಿರಬೇಕು (ಉದಾ: 27.50)",

  // Customer Validation Error Messages
  pleaseEnterValidMilkRate: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಹಾಲಿನ ದರವನ್ನು ನಮೂದಿಸಿ",
  noProRataCollectionsFoundForSelectedDateRange: "ಆಯ್ಕೆ ಮಾಡಿದ ದಿನಾಂಕ ಶ್ರೇಣಿಗೆ ಯಾವುದೇ ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
  // Table Headers
  sNo: "ಕ್ರ.ಸಂ.",
  dateAndShift: "ದಿನಾಂಕ ಮತ್ತು ಶಿಫ್ಟ್",
  date: "ದಿನಾಂಕ",
  name: "ಹೆಸರು",
  qtyKg: "ಪ್ರಮಾಣ (ಕೆಜಿ)",
  fatPercent: "ಫ್ಯಾಟ್ %",
  snfPercent: "SNF %",
  clr: "CLR",
  fatKg: "ಫ್ಯಾಟ್ (ಕೆಜಿ)",
  snfKg: "SNF (ಕೆಜಿ)",
  fatRate: "ಫ್ಯಾಟ್ ದರ",
  snfRate: "SNF ದರ",
  fatStepUp: "ಫ್ಯಾಟ್ ಸ್ಟೆಪ್ ಅಪ್",
  snfStepDown: "SNF ಸ್ಟೆಪ್ ಡೌನ್",
  bRate: "B ದರ",
  rate: "ದರ",
  milkRate: "ಹಾಲಿನ ದರ",
  baseSnf: "ಬೇಸ್ SNF",
  amount: "ಮೊತ್ತ",
  actions: "ಕ್ರಿಯೆಗಳು",
  failedToLoadProRataCollectionsForPreview: "ಪೂರ್ವವೀಕ್ಷಣಕ್ಕಾಗಿ ಪ್ರೋ-ರಾಟಾ ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",

  // Bulk Update Error Messages
  pleaseEnterAtLeastOneValueToUpdate: "ದಯವಿಟ್ಟು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ಕನಿಷ್ಠ ಒಂದು ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿ",
  noCollectionsFoundToUpdate: "ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ಯಾವುದೇ ಸಂಗ್ರಹಗಳು ಕಂಡುಬಂದಿಲ್ಲ",

  // Bulk Update Result Messages
  collectionReachedMaximumEditLimit: "ಸಂಗ್ರಹ {id} ಗರಿಷ್ಠ ಸಂಪಾದನ ಮಿತಿಯನ್ನು ತಲುಪಿದೆ ({message})",
  failedToUpdateCollection: "ಸಂಗ್ರಹ {id} ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ: {message}",
  bulkUpdateFailed: "ಬಲ್ಕ್ ಅಪ್‌ಡೇಟ್ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  collectionReachedMaximumEditLimitWithCount: "ಸಂಗ್ರಹ {id} ಗರಿಷ್ಠ ಸಂಪಾದನ ಮಿತಿಯನ್ನು ತಲುಪಿದೆ ({editCount}/2)",
  invalidCollectionSelectedForDeletion: "ಅಳಿಸಲು ಅಮಾನ್ಯವಾದ ಸಂಗ್ರಹಣೆಯನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
  updatedCollectionsWithMilkRatePartially: "{successful} ಸಂಗ್ರಹಗಳನ್ನು ಹಾಲಿನ ದರದೊಂದಿಗೆ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ. {failed} ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  successfullyUpdatedCollectionsWithMilkRate: "{count} ಸಂಗ್ರಹಗಳನ್ನು ಹಾಲಿನ ದರ {rate} ದೊಂದಿಗೆ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.",
  successfullyUpdatedCollections: "{count} ಸಂಗ್ರಹಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.",
  successfullyUpdatedProRataCollectionsWithRateChart: "{count} ಪ್ರೋ-ರೇಟಾ ಸಂಗ್ರಹಗಳನ್ನು ರೇಟ್ ಚಾರ್ಟ್‌ನೊಂದಿಗೆ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.",
  noCollectionsWereUpdated: "ಯಾವುದೇ ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಸಂಗ್ರಹಗಳು ಅಸ್ತಿತ್ವದಲ್ಲಿವೆ ಎಂದು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  rateChartFunctionalityWillBeImplementedSoon: "ದರ ಚಾರ್ಟ್ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಶೀಘ್ರದಲ್ಲಿ ಅನುಷ್ಠಾನಗೊಳಿಸಲಾಗುವುದು",
  pleaseEnterAValidMilkRate: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಹಾಲಿನ ದರವನ್ನು ನಮೂದಿಸಿ",
  pleaseSelectADate: "ದಯವಿಟ್ಟು ಒಂದು ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  pleaseSelectBothFromAndToDates: "ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ಮತ್ತು ಅಂತಿಮ ಎರಡೂ ದಿನಾಂಕಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  toDateCannotBeEarlierThanFromDate: "ಅಂತಿಮ ದಿನಾಂಕವು ಪ್ರಾರಂಭ ದಿನಾಂಕಕ್ಕಿಂತ ಮುಂಚಿನದಾಗಿರಬಾರದು",
  noCollectionsFoundForTheSelectedDateRange: "ಆಯ್ಕೆ ಮಾಡಿದ ದಿನಾಂಕ ಶ್ರೇಣಿಯಲ್ಲಿ ಯಾವುದೇ ಸಂಗ್ರಹಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
  failedToLoadCollectionsForPreview: "ಪೂರ್ವವೀಕ್ಷಣೆಗೆ ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  failedToApplyMilkRates: "ಹಾಲಿನ ದರಗಳನ್ನು ಅನ್ವಯಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  pleaseSelectADateForFilter: "ದಯವಿಟ್ಟು ಒಂದು ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  pleaseSelectBothFromAndToDatesForFilter: "ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ಮತ್ತು ಅಂತಿಮ ಎರಡೂ ದಿನಾಂಕಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  toDateCannotBeEarlierThanFromDateForFilter: "ಅಂತಿಮ ದಿನಾಂಕವು ಪ್ರಾರಂಭ ದಿನಾಂಕಕ್ಕಿಂತ ಮುಂಚಿನದಾಗಿರಬಾರದು",
  successfullyUpdatedCollectionsWithAccurateAmounts: "✅ {updatedCount} ಸಂಗ್ರಹಗಳನ್ನು ನಿಖರವಾದ ಮೊತ್ತಗಳಿಂದೆ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.\n❌ {errorCount} ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.\n\nವರದಿಗಳು ಈಗಲ ಸರಿಯ ಮೊತ್ತಗಳನ್ನು ತೋರಿಸುತ!\n",
  errorFixingReportAmounts: "❌ ವರದಿ ಮೊತ್ತಗಳನ್ನು ಸರಿಚೆಸಿಸುವುದು. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  customerSelectionIsRequired: "ಗ್ರಾಹಕ ಆಯ್ಕೆ ಅಗತ್ಯವಿದೆ",
  confirmUpdateAllCollectionsWithAccurateAmounts: "ಇದು ಎಲ್ಲಾ ಸಂಗ್ರಹಗಳನ್ನು ನಿಖರವಾದ ಮೊತ್ತಗಳಿಂದೆ ಅಪ್‌ಡೇಟ್ ಮಾಡುತ್ತದೆ. ನೀವು ಖಂಡಿತರಾ?",
  failedToLoadCollections: "ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  failedToLoadCollectionsForCustomerOnDate: "{customerName} ಗಾಗೆ {date} ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  failedToLoadCollectionsForCustomerBetweenDates: "{customerName} ಗಾಗೆ {fromDate} ಮತ್ತು {toDate} ನಡುವೆ ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  failedToLoadCollectionsForCustomer: "{customerName} ಗಾಗೆ ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  failedToLoadCollectionsOnDate: "{date} ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  failedToLoadCollectionsBetweenDates: "{fromDate} ಮತ್ತು {toDate} ನಡುವೆ ಸಂಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  failedToGeneratePreview: "Preview ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  failedToApplyBulkUpdates: "ಬಲ್ಕ್ ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಅನ್ವಯಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  updatedCollectionsWithFieldsPartially: "{successful} ಸಂಗ್ರಹಗಳನ್ನು {fieldsText} ಜೊತೆ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ. {failed} ಸಂಗ್ರಹಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  successfullyUpdatedCollectionsWithFields: "{successful} ಸಂಗ್ರಹಗಳನ್ನು {fieldsText} ಜೊತೆ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.",
  noCollectionsFoundForSelectedDateRangeAndCollectionType: "ಆಯ್ಕೆ ಮಾಡಿದ ತಿಥಿ ಸೀಮಾ ಮತ್ತು ಸಂಗ್ರಹ ಪ್ರಕಾರ ಕೆ ಲಿಯೆ ಯಾವುದೆ.",
  noStandardCollectionsFoundInDateRange: "ಆಯ್ಕೆ ಮಾಡಿದ ದಿನಾಂಕ ಶ್ರೇಣಿಯಲ್ಲಿ ಯಾವುದೇ ಸ್ಟ್ಯಾಂಡರ್ಡ್ ಸಂಗ್ರಹಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
  snfStepMustBeBetween7And12: "SNF ಸ್ಟೆಪ್ 7% ಮತ್ತು 12% ನಡುವೆ ಇರಬೇಕು",
  snfStepMustBeLessThanPreviousSteps: "SNF ಸ್ಟೆಪ್ ಹಿಂದಿನ ಸ್ಟೆಪ್‌ಗಳಿಂತ ಕಡಿಮೆ ಇರಬೇಕು",
  fatStepCannotBeGreaterThan12: "ಫ್ಯಾಟ್ ಸ್ಟೆಪ್ 12% ಗಿಂತ ಹೆಚ್ಚು ಆಗಲಿಸುವುದಿಲ್ಲ",
  fatStepMustBeGreaterThanPreviousSteps: "ಫ್ಯಾಟ್ ಸ್ಟೆಪ್ ಹಿಂದಿನ ಸ್ಟೆಪ್‌ಗಳಿಂತ ದೊಡ್ಡೆ ಇರಬೇಕು",
  milkRateUpdatedToXSuccessfully: "ಹಾಲಿನ ದರ ₹{rate}/L ಗೆ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.",
  supplierXUpdatedSuccessfully: "ಸಪ್ಲೈಯರ್ {name} ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.",

  // Rate Chart Messages
  rateChartSavedSuccessfully: "ದರ ಚಾರ್ಟ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಯಿತು!",
  errorSavingRateChart: "ದರ ಚಾರ್ಟ್ ಅನ್ನು ಉಳಿಸುವಲ್ಲಿ ದೋಷ: {message}",
  errorSavingFatSnfRatio: "FAT/SNF ಅನುಪಾತವನ್ನು ಉಳಿಸುವಲ್ಲಿ ದೋಷ:",

  // Dairy Logo
  dairyLogo: "ಡೈರಿ ಲೋಗೋ",
  logoNotSet: "ಯಾವುದೇ ಲೋಗೋ ಹೊಂದಿಸಲಾಗಿಲ್ಲ",
  logoUpload: "ಲೋಗೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
  logoReplace: "ಲೋಗೋ ಬದಲಾಯಿಸಿ",
  logoRemove: "ಲೋಗೋ ತೆಗೆದುಹಾಕಿ",
  logoSelectFile: "ದಯವಿಟ್ಟು ಮೊದಲು ಲೋಗೋ ಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ.",
  logoMustBePngJpgWebp: "ಲೋಗೋ PNG, JPG, ಅಥವಾ WebP ಚಿತ್ರವಾಗಿರಬೇಕು.",
  logoMustBe2MbOrSmaller: "ಲೋಗೋ 2 MB ಅಥವಾ ಕಡಿಮೆ ಇರಬೇಕು.",
  logoUploadValidImage: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ PNG, JPG, ಅಥವಾ WebP ಚಿತ್ರವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
  logoHint: "ನಿಮ್ಮ ಲೋಗೋ ಪ್ರತಿ PDF ವರದಿಯ ಮೇಲಿನ-ಎಡ ಮೂಲೆಯಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ. PNG, JPG, ಅಥವಾ WebP, ಗರಿಷ್ಠ 2 MB.",
  logoUpdatedSuccessfully: "ಲೋಗೋ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ!",
  logoRemovedSuccessfully: "ಲೋಗೋ ಯಶಸ್ವಿಯಾಗಿ ತೆಗೆದುಹಾಕಲಾಗಿದೆ!",
  logoUploadFailed: "ಲೋಗೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  logoRemoveFailed: "ಲೋಗೋ ತೆಗೆದುಹಾಕಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
  logoRemoveConfirmMessage: "ನೀವು ನಿಜವಾಗಿಯೂ ನಿಮ್ಮ ಡೈರಿ ಲೋಗೋ ತೆಗೆದುಹಾಕಲು ಬಯಸುವಿರಾ?",
  logoChangeButton: "ಲೋಗೋ ಬದಲಾಯಿಸಿ",
};
